/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ConfirmOktaResourceConnectionsRequestBody,
  ConfirmOktaResourceConnectionsRequestBody$Outbound,
  ConfirmOktaResourceConnectionsRequestBody$outboundSchema,
} from "../components/confirmoktaresourceconnectionsrequestbody.js";

export type ConfirmOktaResourceConnectionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ConfirmOktaResourceConnectionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  confirmOktaResourceConnectionsRequestBody:
    ConfirmOktaResourceConnectionsRequestBody;
};

/** @internal */
export type ConfirmOktaResourceConnectionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ConfirmOktaResourceConnectionsSecurity$outboundSchema:
  z.ZodMiniType<
    ConfirmOktaResourceConnectionsSecurity$Outbound,
    ConfirmOktaResourceConnectionsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function confirmOktaResourceConnectionsSecurityToJSON(
  confirmOktaResourceConnectionsSecurity:
    ConfirmOktaResourceConnectionsSecurity,
): string {
  return JSON.stringify(
    ConfirmOktaResourceConnectionsSecurity$outboundSchema.parse(
      confirmOktaResourceConnectionsSecurity,
    ),
  );
}

/** @internal */
export type ConfirmOktaResourceConnectionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ConfirmOktaResourceConnectionsRequestBody:
    ConfirmOktaResourceConnectionsRequestBody$Outbound;
};

/** @internal */
export const ConfirmOktaResourceConnectionsRequest$outboundSchema:
  z.ZodMiniType<
    ConfirmOktaResourceConnectionsRequest$Outbound,
    ConfirmOktaResourceConnectionsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      confirmOktaResourceConnectionsRequestBody:
        ConfirmOktaResourceConnectionsRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        confirmOktaResourceConnectionsRequestBody:
          "ConfirmOktaResourceConnectionsRequestBody",
      });
    }),
  );

export function confirmOktaResourceConnectionsRequestToJSON(
  confirmOktaResourceConnectionsRequest: ConfirmOktaResourceConnectionsRequest,
): string {
  return JSON.stringify(
    ConfirmOktaResourceConnectionsRequest$outboundSchema.parse(
      confirmOktaResourceConnectionsRequest,
    ),
  );
}
